var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto"
    },
    width: "200px",
    height: "200px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 19,
    width: 20,
    height: 20,
    fill: "#5f2a62"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#a976c3;#5f2a62;#5f2a62",
    keyTimes: "0;0.125;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0s",
    calcMode: "discrete"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 19,
    width: 20,
    height: 20,
    fill: "#5f2a62"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#a976c3;#5f2a62;#5f2a62",
    keyTimes: "0;0.125;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0.125s",
    calcMode: "discrete"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 19,
    width: 20,
    height: 20,
    fill: "#5f2a62"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#a976c3;#5f2a62;#5f2a62",
    keyTimes: "0;0.125;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0.25s",
    calcMode: "discrete"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 40,
    width: 20,
    height: 20,
    fill: "#5f2a62"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#a976c3;#5f2a62;#5f2a62",
    keyTimes: "0;0.125;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0.875s",
    calcMode: "discrete"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 40,
    width: 20,
    height: 20,
    fill: "#5f2a62"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#a976c3;#5f2a62;#5f2a62",
    keyTimes: "0;0.125;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0.375s",
    calcMode: "discrete"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 61,
    width: 20,
    height: 20,
    fill: "#5f2a62"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#a976c3;#5f2a62;#5f2a62",
    keyTimes: "0;0.125;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0.75s",
    calcMode: "discrete"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 61,
    width: 20,
    height: 20,
    fill: "#5f2a62"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#a976c3;#5f2a62;#5f2a62",
    keyTimes: "0;0.125;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0.625s",
    calcMode: "discrete"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 61,
    width: 20,
    height: 20,
    fill: "#5f2a62"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#a976c3;#5f2a62;#5f2a62",
    keyTimes: "0;0.125;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0.5s",
    calcMode: "discrete"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/Loader.1b51330b1c703c25eda075f7fdf212a8.svg";
export { ForwardRef as ReactComponent };